import hotjar from '@hotjar/browser';

const HOTJAR_SITE_ID = process.env.REACT_APP_HOTJAR_SITE_ID || '0000000'; // Replace with your Hotjar Site ID
const HOTJAR_VERSION = 6;

export const initHotjar = () => {
    hotjar.init(HOTJAR_SITE_ID, HOTJAR_VERSION);
};
